import { Box } from "../../../../../../mads";
import { useViewjobOneGraphModel } from "../../../../context/ViewJobDataContext";
import { useIsDesktopDisplay } from "../../../../context/ViewJobDisplayContext";
import { Banner } from "../Banner";
import { Logo } from "../Logo";

import React from "react";
import { StyleSheet } from "react-native";

// These Model interfaces will be replaced by types generated from GraphQL fragments.
interface CompanyImagesModel {
  logoUrl?: string;
  headerImageUrl?: string;
  logoImageOverlayLower: boolean;
  logoAltText: string;
}

export type BrandedHeaderProps = {
  companyImagesModel?: CompanyImagesModel;
};

/**
 * The top banner for the page showing branding information for the company, this will show the banner and an optional
 * logo if it is present.
 */
export const BrandedHeader = ({ companyImagesModel }: BrandedHeaderProps) => {
  const isDesktop = useIsDesktopDisplay();

  if (!companyImagesModel) {
    return null;
  }

  const hasLogo = companyImagesModel.logoUrl && companyImagesModel.logoImageOverlayLower;
  const useDesktopBrandedLayout =
    isDesktop && !!companyImagesModel.headerImageUrl && !!companyImagesModel.logoUrl && hasLogo;

  if (useDesktopBrandedLayout) {
    return (
      <>
        <Box sx={styles.desktopBannerWrapper} testID="desktop-branded-banner">
          <Banner
            url={companyImagesModel.headerImageUrl!}
            altText={companyImagesModel.logoAltText}
            fixedHeight={130}
          />
          <Box sx={styles.desktopLogoPosition} testID="desktop-branded-logo-position">
            <Logo
              url={companyImagesModel.logoUrl!}
              altText={companyImagesModel.logoAltText}
              size={56}
              hasShadow={true}
              shadowLevel="low"
              hasBorder={true}
            />
          </Box>
        </Box>
        <Box sx={styles.desktopTitleReservation} testID="desktop-branded-title-reservation" />
      </>
    );
  }

  return (
    <>
      {companyImagesModel.headerImageUrl && (
        <Banner url={companyImagesModel.headerImageUrl} altText={companyImagesModel.logoAltText} />
      )}

      {hasLogo ? (
        <Box sx={styles.logoPosition}>
          <Logo
            url={companyImagesModel.logoUrl!}
            altText={companyImagesModel.logoAltText}
            size={60}
            hasShadow={true}
            hasBorder={false}
          />
        </Box>
      ) : (
        // add a bit of spacing if there is no logo
        <Box sx={styles.bannerOnlySpacing} />
      )}
    </>
  );
};

const styles = StyleSheet.create({
  // Used to shift the logo over the banner.
  logoPosition: {
    zIndex: 1,
    marginLeft: 16,
    bottom: 32,
    marginBottom: -24,
  },
  bannerOnlySpacing: {
    marginTop: 16,
  },
  desktopBannerWrapper: {
    position: "relative",
  },
  desktopLogoPosition: {
    position: "absolute",
    zIndex: 1,
    left: 16,
    bottom: -28,
  },
  desktopTitleReservation: {
    height: 48,
  },
});

export interface OGWrappedBrandedHeaderProps {}

export function OGWrappedBrandedHeader({}: OGWrappedBrandedHeaderProps) {
  const ogModel = useViewjobOneGraphModel();

  if (ogModel == null || ogModel.employer?.companyImagesModel == null) {
    return null;
  }

  return <BrandedHeader companyImagesModel={ogModel.employer.companyImagesModel} />;
}
